<template>
    <div class="row">
        <div class="col-12">
            <div class="col-12">
                <h1 class="title-tab-content">پرسش و پاسخ</h1>
            </div>
            <div class="content-section default">
                <div v-if="customerQuestions.length > 0" class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div v-for="info in customerQuestions" class="review-all">
                            <div class="row">
                                <div class="flex col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                    <div class="div-img">
                                        <img :src="info.ProductPicPath" />
                                    </div>
                                </div>
                                <div class="main-review col-lg-9 col-md-9 col-sm-12 col-xs-12">
                                    <span class="wait" v-if="info.IsAnswered == true">پاسخ داده شده</span>
                                    <span class="not-wait" v-if="info.IsAnswered == false">در انتظار پاسخ دهی</span>
                                    <h2 class="right text-txt-main">{{info.Question }} </h2>
                                    <!--<p v-text="info.Answer" class="text-review"></p>-->
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="row">
                                        <div class="right date col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <span class="date-ware sabt">{{'تاریخ ثبت : ' + info.RegDateTime}}</span><br />
                                            <span v-if="info.IsAnswered" class="date-ware tayid">{{ 'تاریخ پاسخ : ' + info.AnsweredDateTime}}</span>
                                        </div>
                                        <div class="left  col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div class="parent-btn all-btn">
                                                <button name="edit" @click="findCustomerQuestion(info.Id)" class="btn btn-sm btn-info">نمایش جزئیات</button>
                                                <button name="delete" @click="deleteCustomerQuestion(info.Id)" class="btn btn-danger btn-sm">
                                                    حذف
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="customerQuestionsPaging" class="pager default text-center"></div>
                </div>
                <div v-else class="row">
                    <div class="empty-div col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div><img src="/assets/img/svg/form.svg" /></div>
                        <div><p>پرسش و پاسخی برای شما ثبت نشده است.</p></div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%"><img style="position:absolute;top:50%;left:50%;z-index:100" src="/assets/img/loader/loader.svg" /></div>
        <edit-question-modal :questionInfo="questionInfo"></edit-question-modal>
    </div>
</template>
<script>
    import { httpPromise } from "../../../module/httpUtility";
    import { questionChangedEventBus } from "../../../eventBus/eventBus";
    import editQuestionModal from "./editQuestionModal.vue";
    export default {
        data() {
            return {
                questionInfo: {},
                customerQuestions: []
            }
        },
        components: {
            'edit-question-modal': editQuestionModal
        },
        created() {
            questionChangedEventBus.$on('updateQuestionEvent', () => {
                this.readCustomersQuestion(0);
            });
        },
        beforeMount: function () {
            createPageTitle('پرسش و پاسخ');
            this.readCustomersQuestion(0);

        },
        methods: {
            readCustomersQuestion(pageNum) {
                this.isShowSppiner = true;
                httpPromise(this, '/v1/ProductManagement/customerQuestions/Read', 'get', { Page: pageNum },
                    response => {
                        this.customerQuestions = response.data.Value.FilteredQuestions;
                        this.createPaging(response.data.Value.TotalCount, response.data.Value.Page);
                        this.isShowSppiner = false;
                        $(function () { $('html, body').animate({ scrollTop: 0 }, 800, 'easeInExpo'); })
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },
            findCustomerQuestion(Id) {
                httpPromise(this, '/v1/ProductManagement/customerQuestions/Find', 'get', { Id: Id },
                    response => {
                        toastr.remove();
                        this.questionInfo = response.data.Value;
                        this.isShowSppiner = false;
                        this.openEditQuestionModal();
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            },
            deleteCustomerQuestion(Id) {
                if (confirm("آیا از حذف این نظر اطمینان دارید ؟")) {
                    this.isShowSppiner = true;
                    httpPromise(this, '/v1/ProductManagement/customerQuestions/Delete', 'delete', { QuestionId: Id },
                        response => {
                            toastr.remove();
                            toastr.success(response.data.Message);
                            this.isShowSppiner = false;
                            this.readCustomersQuestion();
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowSppiner = false;
                        });
                }
            },
            createPaging(totalDataCount, pageNumber) {
                var component = this;
                $(function () {
                    try {
                        $('#customerQuestionsPaging').pagination('destroy');
                    } catch  { }
                    var dataSource = [];
                    for (var i = 1; i <= totalDataCount; i++)
                        dataSource.push(i);
                    if (dataSource != null && dataSource.length > 0) {
                        var container = $('#customerQuestionsPaging').pagination({
                            dataSource: dataSource,
                            pageSize: 10,
                            pageNumber: pageNumber,
                            classPrefix: 'pager',
                            ulClassName: 'pager-items',
                            activeClassName: 'is-active',
                        });
                        container.addHook('afterPaging', function () {
                            var pageNum = container.pagination('getSelectedPageNum');
                            component.readCustomersQuestion(pageNum);
                        });
                    }

                });
            },
            openEditQuestionModal() {
                $(function () {
                    $('#editQuestionModal').modal({ backdrop: 'static', keyboard: false });
                    $('#editQuestionModal').modal('show');
                });
            }
        },
    }
</script>

<style scoped>
    .date-ware {
        font-size: 12px
    }
    .sabt {
        color: #ee0551;
    }
    .tayid {
        color: green;
    }

    .btn-warning:focus, .btn-warning:active {
        color: #fff !important;
    }

    .empty-div {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

        .empty-div img {
            width: 100px;
        }

        .empty-div p {
            font-size: 16px !important;
            line-height: 2;
            color: #555 !important;
        }

    .date {
        font-size: 14px;
        color: #777;
        font-weight: 400;
    }

    .all-btn .btn-info {
        font-size: 14px;
        padding: 5px 15px !important;
        font-weight: unset !important;
    }

    .text-txt-main {
        white-space: pre-wrap;
        font-size: 13px;
        line-height: 2;
        color: #939393;
    }


    .div-img {
        width: 100px;
    }

    .review-all {
        margin-bottom: 10px;
        border: 1px solid aqua;
        border-radius: 7px;
        padding: 7px;
    }

    .main-review {
        position: relative;
    }

        .main-review .wait {
            padding: 4px;
            border: 1px solid green;
            color: green;
            border-radius: 5px;
            position: absolute;
            top: 10px;
            left: 27px;
        }
        .main-review .not-wait {
            padding: 4px;
            border: 1px solid #ff6a00;
            color: #ff6a00;
            border-radius: 5px;
            position: absolute;
            top: 10px;
            left: 27px;
        }
    main.profile-user-page .content-section p {
        font-size: 13px;
        line-height: 2;
        color: #939393;
    }

    .flex {
        flex-direction: column;
    }

        .flex .img-title {
            font-size: 12px;
        }

    .right {
        margin-top: 15px;
        margin-bottom: 5px;
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .empty-div p {
            font-size: 13px !important;
        }


        .div-img {
            width: 160px;
        }

        main.profile-user-page .content-section p {
            font-size: 12px;
        }

        .right {
            margin-top: 35px;
            font-size: 15px;
            padding-left: 20px;
        }

        .main-review .wait {
            padding: 4px;
            font-size: 11px;
        }
    }
</style>